import { bind } from "@react-rxjs/core"
import { createSignal } from "@react-rxjs/utils"

import {
  filterNotNull,
  type Periodicity,
  timeframeConfig,
} from "@/App/Equities/shared/utils"

const [_currentSymbol$, setCurrentSymbol] = createSignal<string | undefined>()
const [useCurrentSymbol, currentSymbol$] = bind(
  _currentSymbol$.pipe(filterNotNull()),
)

export { currentSymbol$, setCurrentSymbol, useCurrentSymbol }

const [_periodicity$, setPeriodicity] = createSignal<Periodicity>()
export const [usePeriodicity, periodicity$] = bind<Periodicity>(
  _periodicity$,
  timeframeConfig["1h"], // default to 1hour
)

export { setPeriodicity }
